export enum SupplierType {
  PrivatePerson = 0,
  LegalEntity = 1
}
